import styled from 'styled-components';
import {
  AccordionItem,
  Divider,
  H3,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
  radiusHelper,
  mediaHelper,
  boxShadow,
} from '@property.com.au/ui-kit';

export const StyledChildcareAccordionItem = styled(AccordionItem)`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border: none;
  border-radius: ${radiusHelper('medium')};
  ${boxShadow.defaultBoxShadow};
  margin-bottom: ${spacingHelper('extraSmall')};

  .headerButton {
    border-radius: ${radiusHelper('medium')};
    /* override rules so that button color doesn't change on hover */
    &:hover {
      background-color: initial;
    }
    &:focus-visible {
      background-color: transparent;
      outline: solid calc(${spacingHelper('twoExtraSmall')} / 2);
    }
  }
  .content {
    padding-top: 0;
  }

  &:last-of-type {
    /* override accordion rule that last item has a bottom border */
    border-bottom: none;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const CHILDCARE_NAME_WIDTH = 258;

export const ChildcareName = styled(H3)`
  ${typographyHelper('body02Bold')};
  ${mediaHelper('tabletMin')} {
    width: ${CHILDCARE_NAME_WIDTH}px;
  }
`;

export const ChildcareFactsTable = styled.div`
  ${mediaHelper('desktopMin')} {
    display: none;
  }
  margin-bottom: ${spacingHelper('medium')};
`;

export const StyledDivider = styled(Divider)`
  margin: ${spacingHelper('extraSmall')} 0;
  border-color: ${paletteHelper('borderPrimary')};
`;

export const ChildcareFactsTitle = styled(Text)`
  flex: 1;
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
`;

export const ChildcareFactsSubtitle = styled.div`
  flex: 1;
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
`;

export const LinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  a {
    margin-top: ${spacingHelper('twoExtraSmall')};
    margin-bottom: ${spacingHelper('twoExtraSmall')};
    &:not(:last-child) {
      margin-right: ${spacingHelper('extraSmall')};
    }
  }
`;

export const DesktopChildcareFactsSubtitleWrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    display: none;
  }
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-left: ${spacingHelper('medium')};
`;

export const CHILDCARE_FACT_WIDTH = [132, 157, 90, 70];

export const DesktopChildcareFactsSubtitle = styled.div<{ index: number }>`
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
  width: ${(props) => CHILDCARE_FACT_WIDTH[props.index]}px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: ${spacingHelper('medium')};
`;

export const ChildcareAddress = styled(Text)`
  flex: 1;
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
  padding-bottom: ${spacingHelper('small')};
`;

export const ChildcareOpeningHours = styled(Text)`
  flex: 1;
  ${typographyHelper('overline')}
  color: ${paletteHelper('textSecondary')};
  padding-bottom: calc(${spacingHelper('twoExtraSmall')} / 2);
`;

export const VacanciesStatusBadgeWrapper = styled.div`
  padding: ${spacingHelper('twoExtraSmall 0 small')};
`;
